import { type RouteObject } from 'react-router-dom';

import { HelpPage } from '~/b4b/features/help/HelpPage';
import { HomePage } from '~/b4b/features/home/HomePage';
import { ReportsPage } from '~/b4b/features/reports/ReportsPage';
import { ResourcesPage } from '~/b4b/features/resources/ResourcesPage';
import { TasksPage } from '~/b4b/features/tasks/TasksPage';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { GenerateReportsPage } from '../reports/GenerateReportsPage';

/**
 * SPA route definitions for React Router and AutoLinkContext.
 * These routes will be handled client-side within the SPA.
 */
export const routes: RouteObject[] = [
  {
    path: urlBuilder.reports.path,
    element: <ReportsPage />,
  },
  {
    path: `${urlBuilder.reportsNew.path}/*`,
    element: <GenerateReportsPage />,
  },
  {
    path: urlBuilder.help.path,
    element: <HelpPage />,
  },
  {
    path: `${urlBuilder.resources.path}/*`,
    element: <ResourcesPage />,
  },
  {
    path: urlBuilder.home.path,
    element: <HomePage />,
  },
  {
    path: urlBuilder.tasks.path,
    element: <TasksPage />,
  },
];
